<template>
  <div class="">
    <!-- Hero Section -->
    <div class="relative z-0 overflow-hidden bg-main_blue">
      <!-- Large Circular Background Elements -->
      <div class="absolute bottom-0 left-0 w-full h-full">
        <div
          class="absolute -bottom-1/2 -left-1/4 w-[120%] h-[120%] bg-gradient-to-t from-white/20 via-white/10 to-transparent rounded-full"
        ></div>
        <div
          class="absolute -bottom-2/3 -left-1/3 w-[140%] h-[140%] bg-gradient-to-t from-blue-400/30 via-blue-300/15 to-transparent rounded-full"
        ></div>
      </div>

      <!-- Small Decorative Circles -->
      <div
        class="absolute top-16 right-16 w-12 h-12 bg-blue-300/40 rounded-full opacity-90 hidden md:block"
      ></div>
      <div
        class="absolute bottom-32 left-16 w-16 h-16 bg-blue-300/40 rounded-full hidden md:block"
      ></div>

      <section
        class="min-h-screen bg-blue flex items-center justify-center px-4 py-16"
      >
        <div
          class="flex flex-col items-center justify-center max-w-4xl w-full text-center"
        >
          <!-- Top Content Block -->
          <div class="w-full max-w-3xl text-center mb-6 px-4 mt-14">
            <div
              class="inline-block bg-yellow/10 text-yellow px-4 py-1 rounded-full text-base md:text-xl font-semibold tracking-wide uppercase mb-5"
            >
              Welcome to Mshel Homes
            </div>
            <h1
              class="text-3xl md:text-4xl lg:text-4xl font-extrabold text-white leading-snug mb-4"
            >
              Redefine Your Real Estate Experience...!
            </h1>
            <p class="text-base md:text-lg text-white/90 leading-relaxed mb-8">
              We create generational wealth with estate lands, apartments and
              houses in strategic locations known for high returns and values.
            </p>
          </div>

          <!-- Bottom Carousel Block -->
          <div class="relative w-full max-w-3xl">
            <!-- Main Carousel Card -->
            <div
              class="relative w-full h-64 md:h-80 lg:h-[26rem] bg-white rounded-2xl shadow-2xl overflow-hidden transform rotate-1 hover:rotate-0 transition-transform duration-500"
            >
              <div
                class="carousel-slide absolute inset-0 opacity-0 transition-opacity duration-500 ease-in-out"
                v-for="(slide, index) in slides"
                :key="index"
                :class="{ 'opacity-100': currentSlide === index }"
              >
                <img
                  :src="slide.image"
                  :alt="slide.alt"
                  class="w-full h-full object-cover"
                />
              </div>

              <!-- MSh logo overlay -->
              <div
                class="absolute top-3 right-3 bg-white/95 rounded-lg px-2.5 py-1.5 shadow-sm"
              >
                <span class="text-blue-900 font-bold text-sm">MS</span>
                <span class="text-yellow font-bold text-sm">h</span>
                <span class="text-gray-500 text-xs">el</span>
                <span class="text-main_blue text-xs">Homes</span>
              </div>
            </div>

            <!-- Navigation Buttons -->
            <button
              @click="prevSlide"
              class="absolute top-1/2 -left-6 -translate-y-1/2 w-10 h-10 bg-white rounded-full flex items-center justify-center text-gray-600 text-lg shadow-lg hover:shadow-xl transition-all duration-300 z-20 hover:scale-110"
            >
              ‹
            </button>
            <button
              @click="nextSlide"
              class="absolute top-1/2 -right-6 -translate-y-1/2 w-10 h-10 bg-white rounded-full flex items-center justify-center text-gray-600 text-lg shadow-lg hover:shadow-xl transition-all duration-300 z-20 hover:scale-110"
            >
              ›
            </button>

            <!-- Indicators -->
            <div
              class="absolute -bottom-6 left-1/2 -translate-x-1/2 flex gap-2 z-10"
            >
              <button
                v-for="(slide, index) in slides"
                :key="index"
                @click="goToSlide(index)"
                class="w-2 h-2 rounded-full transition-all duration-300 hover:scale-125"
                :class="currentSlide === index ? 'bg-white' : 'bg-white/50'"
              ></button>
            </div>
          </div>
        </div>
      </section>
    </div>

    <!-- Statistics Section -->
    <!-- <div class="relative -mt-6 md:-mt-10 pb-12 md:pb-16">
      <div class="max-w-5xl mx-auto px-6">
        <div
          class="flex flex-col md:flex-row justify-center items-center gap-6 md:gap-12 lg:gap-20"
        >
          <div
            class="flex items-center gap-4 bg-white rounded-2xl px-6 py-4 shadow-lg hover:shadow-xl transition-shadow duration-300 w-full md:w-auto"
          >
            <div class="flex">
              <div
                v-for="i in 5"
                :key="i"
                class="w-10 h-10 md:w-12 md:h-12 rounded-full border-3 md:border-4 border-white shadow-md -mr-2 md:-mr-3 flex-shrink-0"
                :class="getAvatarColor(i)"
              ></div>
            </div>
            <div class="min-w-0">
              <div class="text-lg md:text-xl font-bold text-gray-900">
                72k+ Happy
              </div>
              <div class="text-sm md:text-base text-gray-600">Customers</div>
            </div>
          </div>

          <div
            class="flex items-center gap-4 bg-white rounded-2xl px-6 py-4 shadow-lg hover:shadow-xl transition-shadow duration-300 w-full md:w-auto"
          >
            <div
              class="w-12 h-12 md:w-14 md:h-14 bg-blue-100 rounded-xl flex items-center justify-center flex-shrink-0"
            >
              <div
                class="w-6 h-6 md:w-7 md:h-7 bg-blue-600 rounded-sm flex items-center justify-center"
              >
                <div class="w-3 h-3 md:w-4 md:h-4 bg-white rounded-sm"></div>
              </div>
            </div>
            <div class="min-w-0">
              <div class="text-lg md:text-xl font-bold text-gray-900">
                200+ properties
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->

    <!-- Call to Action Section -->
    <div
      class="text-center opacity-0 animate-fade-in-up -mt-6"
      style="animation-delay: 0.6s; animation-fill-mode: forwards"
    >
      <a
        href="https://mshelhomes.com/"
        target="_blank"
        class="inline-flex items-center space-x-4 bg-yellow rounded-full px-6 py-4 shadow-lg border border-none hover:shadow-xl transition-all duration-300 cursor-pointer group"
      >
        <span class="text-white font-semibold text-base">Visit Mshel Homes</span>
        <svg
          class="w-6 h-6 text-white group-hover:translate-x-2 transition-transform duration-300"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M17 8l4 4m0 0l-4 4m4-4H3"
          ></path>
        </svg>
      </a>
    </div>

    <!-- Other sections -->
    <aboutMshelHomes />
    <mshelGallery />
  </div>
</template>

<script>
import aboutMshelHomes from "../components/aboutMshelHomes.vue";
import mshelGallery from "../components/mshelGallery.vue";

export default {
  name: "MshelHomes",
  components: {
    aboutMshelHomes,
    mshelGallery,
  },
  data() {
    return {
      currentSlide: 0,
      slides: [
        {
          image: require('../assets/images/About-Us.jpg'),
          alt: "Modern house exterior",
        },
        {
          image: require('../assets/images/hedge-court.jpg'),
          alt: "Luxury home",
        },
        {
          image: require('../assets/images/kapital-villa.jpg'),
          alt: "Contemporary house",
        },
      ],
      autoSlideInterval: null,
    };
  },
  mounted() {
    this.startAutoSlide();
  },
  beforeUnmount() {
    if (this.autoSlideInterval) {
      clearInterval(this.autoSlideInterval);
    }
  },
  methods: {
    nextSlide() {
      this.currentSlide = (this.currentSlide + 1) % this.slides.length;
    },
    prevSlide() {
      this.currentSlide =
        this.currentSlide === 0
          ? this.slides.length - 1
          : this.currentSlide - 1;
    },
    goToSlide(index) {
      this.currentSlide = index;
    },
    startAutoSlide() {
      this.autoSlideInterval = setInterval(() => {
        this.nextSlide();
      }, 5000);
    },
    getAvatarColor(index) {
      const colors = [
        "bg-orange-400",
        "bg-red-500",
        "bg-purple-500",
        "bg-blue-500",
        "bg-green-500",
      ];
      return colors[index - 1];
    },
  },
};
</script>

<style scoped>
.carousel-slide {
  transition: opacity 0.5s ease-in-out;
}

/* Custom responsive utilities */
@media (max-width: 768px) {
  .min-h-screen {
    min-height: 100vh;
  }
}

@keyframes fade-in-up {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.animate-fade-in-up {
  animation: fade-in-up 0.8s ease-out;
}
</style>
